module.exports = __webpack_public_path__ + "static/media/video_uploaded_placeholder.0e2ce942.svg";